/**
 *@author yudeping
 *年份控件
 */
import Component from '../../../lib/component'
import {AutoSelect} from "../../util/autoSelect/autoSelect"
import {FormService} from "../../../services/formService/formService";
import template from './year-control.html'
import WXtemplate from './year-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';

let config={
    template:template,
    data:{
        options:[],
    },
	actions:{
    	init(){
		    let myDate = new Date();
		    let myYear = myDate.getFullYear();
		    this.data.options = [];
		    for( let i=5;i>=-10;i-- ){
			    this.data.options.push( { "label": String(myYear + i),"value": String(myYear + i)} );
		    }
		    if(this.data.value == ''){
			    this.data.value = myYear;
		    }
		    this.data.options.unshift({"label":"请选择","value":"请选择"});

		    let _this=this;
		    this.data.isInit=true;
		    // if (this.data.is_view) {
			    for(let k in this.data.options) {
				    if(this.data.value == this.data.options[k].value) {
					    this.el.find('.dropdown').attr('title',this.data.options[k].label)
				    }
			    }
		    // }
		    if(!this.data.be_control_condition) {
			    let el=this.el.find('.dropdown');
			    let data=FormService.createSelectJson(this.data);
			    data.onSelect=this.actions.createSelectAction(_this);
			    let autoSelect=new AutoSelect({data:data});
			    this.append(autoSelect,el);
		    }
		    this.data.isInit=false;
	    },
		iconCheck(){
			if(this.data.history){
				this.el.find('.ui-history').css('visibility','visible');
			}
		},
		createSelectAction(_this){
			return function(data){
				if(_this.data.isInit || !data || data.length == 0 ){
					if(!_this.data.isInit){
						_this.data.value='';
						_.debounce(function(){_this.events.changeValue(_this.data)},200)();
					}
					return;
				}
				_this.data.value=data[0]['id'];
				_.debounce(function(){_this.events.changeValue(_this.data)},200)();
			};
		}
	},
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data);
            }
        }
    ],
    afterRender(){
    	this.actions.iconCheck();
        this.actions.init();
    },
    beforeDestory(){
        this.el.off();
    }
}
let YearControl = Component.extend(config)
export default YearControl;

let WXconfig={
	data:Object.assign({},config.data,{controlHtml:WXtemplate}),
	actions:Object.assign({},config.actions,{
		createSelectAction(_this){
			return function(data){
				if(_this.data.isInit || !data || data.length == 0 ){
					if(!_this.data.isInit){
						_this.data.value='';
					}
					return;
				}
				_this.data.value=data[0]['id'];
			};
		}
	}),
	afterRender(){
		this._super.afterRender();
		this.actions.init();
	}
}
let YearControlWX=BaseControl.extend(WXconfig);
export {YearControlWX}



// WEBPACK FOOTER //
// app/components/form/year-control/year-control.js